import { useCallback } from 'react';
import { useMutation } from '@apollo/client';

import { ENROLL_PATIENT } from '@/apollo/mutations';
import { getPdtUid, Product } from '@/utils/productHelpers';

type EnrollArgs = {
  email: string;
  firstName: string;
  lastName: string;
  password: string;
  phone?: string;
  product: Product;
  springId: string;
};

export const useEnrollSleepioSpringHealth = () => {
  const [enrollDirectAccessPatient, { loading }] = useMutation(ENROLL_PATIENT);

  const enroll = useCallback(async (args: EnrollArgs) => {
    const response = await enrollDirectAccessPatient({
      variables: {
        email: args.email.trim(),
        firstName: args.firstName,
        lastName: args.lastName,
        password: args.password,
        phone: args.phone || null,
        pdtUid: getPdtUid(args.product),
        externalId: args.springId,
        organizationSlug: 'spring-health',
        termsAndPrivacyAcknowledgedAt: new Date().toISOString(),
      },
    });

    return response;
  }, [enrollDirectAccessPatient]);

  return { enroll, loading };
};
